export default __webpack_public_path__ + "static/media/large.5665e522.jpg";